import useFieldValidation from 'hooks/useFieldValidation';
function useProductParameterValidation(form, t) {
    return useFieldValidation(['name'], () => { var _a; return (!((_a = form.name) === null || _a === void 0 ? void 0 : _a.trim()) ? t('specification:required_field') : null); }, () => t('common:name'));
}
export default useProductParameterValidation;
